var gaStats = new GaStatistics();

$(document).ready(function() {
    gaStats.init();
});